import { createReducer } from '@reduxjs/toolkit';

import * as elementActions from '../actions/elements.action';
import * as pageActions from '../actions/page.action';

const initialState = {};

const numberOrNull = (value) => typeof value === 'number' && !isNaN(value) ? value : null;
const mapElementToState = (element) => {
  return {
    id: element.id,
    pageId: element.pageId,
    dataset: element.dataset,
    type: element.type,
    x: numberOrNull(element.x),
    y: numberOrNull(element.y),
    width: numberOrNull(element.width),
    height: numberOrNull(element.height),
    rotation: element.rotation,
    nodeString: element.nodeString,
    orderedList: element.orderedList,
    isLastLineEol: element.isLastLineEol
  };
};

const setElement = (state, { payload }) => {
  const element = payload;
  const { id, pageId, ...data } = mapElementToState(element);

  state[pageId] = {
    ...state[pageId],
    [id]: {
      ...data,
      id
    }
  };
};

const setElements = (state, action) => {
  const elements = action.payload;

  Object.values(elements).forEach((element) => {
    setElement(state, { payload: element });
  });
};

const setElementsFromPage = (state, action) => {
  const { id: pageId, elements } = action.payload;

  delete state[pageId];

  Object.values(elements).forEach((element) => {
    setElement(state, { payload: element });
  });
};

const deleteElement = (state, { payload }) => {
  const { pageId, elementId } = payload;

  if (state[pageId]?.[elementId]) {
    delete state[pageId][elementId];
  }
};

const deleteElementsFromPage = (state, { payload }) => {
  const { id: pageId } = payload;

  delete state[pageId];
};

export default createReducer(initialState, builder => {
  builder
    .addCase(elementActions.setElement, setElement)
    .addCase(elementActions.setElements, setElements)
    .addCase(elementActions.deleteElement, deleteElement)
    .addCase(pageActions.deletePage, deleteElementsFromPage)
    .addCase(pageActions.setElementsFromPage.fulfilled, setElementsFromPage);
});
